<script setup>
  import { computed } from 'vue'
  import { useUserStore } from '@/stores/UserStore';
  import useSettingsGlobals from '@/composables/useSettingsGlobals';
  import useSecureUrls from '@/composables/useSecureUrls';
  import Icon from './icons/Icon.vue';

  const props = defineProps({
    isSmallDevice: {
      type: Boolean,
      required: true
    }
  });

  const userStore = useUserStore();

  const { $WEB_VIEW, $PLATFORM } = useSettingsGlobals();
  const { upgradeUrl } = useSecureUrls();

  const message = computed(() => userStore.memberLevel < 46 ? 'Get PRO & Plus stations!' : 'Get PRO stations!');
  const isWebView = computed(() => $WEB_VIEW);
  const buttonClasses = computed(() => "jwx-map__upgrade-button map-upgrade-button jwx-button jwx-button--pill jwx-button--shadow jwx-button--border");

  function upgradeButtonClickHandler(e) {
    // TODO: Make composable
    if (isWebView.value) {
      const info = {
        type: "membership-required",
      };

      if ($PLATFORM === "android") {
        const params = [
          info.type
        ];

        alert(params.join(","));
      } else {
        window.webkit.messageHandlers.observe.postMessage(info);
      }
    }     
  }
</script>

<template>
  <Teleport to=".jwx-map__bottom-container" :disabled="!props.isSmallDevice">
    <button
      v-if="isWebView"
      type="button"
      @click.prevent="upgradeButtonClickHandler"
      :class="buttonClasses">
      {{ message }}
      <Icon name="chevron-right" class="map-upgrade-button__icon" />
    </button>
    <a
      v-else
      :href="upgradeUrl"
      :class="buttonClasses"
    >
      {{ message }}
      <Icon name="chevron-right" class="map-upgrade-button__icon" />
    </a>
  </Teleport>
</template>